module.exports = __webpack_public_path__ + "static/media/landingStoreSelect.c5c3bb7b.png";